import { PlayerService } from '@modules/player/player-service';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';

export class PlayerField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/player',
      Permissions.values.playerRead,
      PlayerService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.id,
        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/player',
      Permissions.values.playerRead,
      PlayerService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.id,
        };
      },
      options,
    );
  }
}
